import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";

const AssignSubjects = () => {
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubjectIDs, setSelectedSubjectIDs] = useState([]);
  const [assignedSubjects, setAssignedSubjects] = useState([]);

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (selectedCourse) {
      fetchClassesByCourse(selectedCourse);
    } else {
      setClasses([]);
      setSelectedClass("");
    }
  }, [selectedCourse]);

  useEffect(() => {
    if (selectedCourse && selectedClass) {
      fetchAssignedSubjects();
    } else {
      setAssignedSubjects([]);
    }
  }, [selectedCourse, selectedClass]);

  const fetchInitialData = async () => {
    try {
      const [courseRes, subjectRes] = await Promise.all([
        axios.get(`${BASE_URL}/api/subjectClassCourse/getcourse`),
        axios.get(`${BASE_URL}/api/subjects`),
      ]);
      setCourses(courseRes.data);
      setSubjects(subjectRes.data);
    } catch (err) {
      console.error("Error fetching initial data", err);
    }
  };

  const fetchClassesByCourse = async (courseId) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseId}`);
      setClasses(res.data);
      setSelectedClass("");
    } catch (err) {
      console.error("Error fetching classes", err);
    }
  };

  const fetchAssignedSubjects = async () => {
    try {
        debugger;
      const res = await axios.get(`${BASE_URL}/api/subjectClassCourse`);
      const filtered = res.data.filter(
        (item) =>
          item.CourseID === parseInt(selectedCourse) &&
          item.ClassID === parseInt(selectedClass)
      );
      setAssignedSubjects(filtered);
    } catch (err) {
      console.error("Error fetching assigned subjects", err);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedSubjectIDs((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  };

  const handleAssignSubjects = async () => {
    try {
      for (const subjectID of selectedSubjectIDs) {
        await axios.post(`${BASE_URL}/api/subjectClassCourse`, {
          SubjectID: subjectID,
          ClassID: selectedClass,
          CourseID: selectedCourse,
        });
      }
      setSelectedSubjectIDs([]);
      fetchAssignedSubjects();
      alert("Subjects assigned successfully.");
    } catch (err) {
      console.error("Error assigning subjects", err);
    }
  };

  const handleDeleteMapping = async (id) => {
    if (!window.confirm("Are you sure you want to remove this subject mapping?")) return;
    try {
      await axios.delete(`${BASE_URL}/api/subjectClassCourse/${id}`);
      fetchAssignedSubjects();
    } catch (err) {
      console.error("Error deleting mapping", err);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Assign Subjects to Course and Class</h3>

      <div className="row mb-3">
        <div className="col-md-4">
          <label>Course</label>
          <select
            className="form-select"
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.CourseId} value={course.CourseId}>
                {course.CourseName}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Class</label>
          <select
            className="form-select"
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            disabled={!selectedCourse}
            required
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.id} value={cls.id}>
                {cls.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <h5>Select Subjects</h5>
      <div className="row">
        {subjects.map((subj) => (
          <div className="col-md-3" key={subj.SubjectID}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={subj.SubjectID}
                checked={selectedSubjectIDs.includes(subj.SubjectID)}
                onChange={() => handleCheckboxChange(subj.SubjectID)}
              />
              <label className="form-check-label">{subj.SubjectName}</label>
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn btn-success mt-3"
        onClick={handleAssignSubjects}
        disabled={!selectedCourse || !selectedClass || selectedSubjectIDs.length === 0}
      >
        Assign Selected Subjects
      </button>

      <hr />

      <h5>Assigned Subjects</h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Subject</th>
            <th>Course</th>
            <th>Class</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {assignedSubjects.map((item) => (
            <tr key={item.ID}>
              <td>{item.SubjectName}</td>
              <td>{item.CourseName}</td>
              <td>{item.ClassName}</td>
              <td>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDeleteMapping(item.ID)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AssignSubjects;
